"use strict";

var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;

var _asyncToGenerator = require("/app/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.array.fill.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pbkdf2Async = exports.pbkdf2 = void 0;

var hmac_js_1 = require("./hmac.js"); // prettier-ignore


var utils_js_1 = require("./utils.js"); // Common prologue and epilogue for sync/async functions


function pbkdf2Init(hash, _password, _salt, _opts) {
  (0, utils_js_1.assertHash)(hash);
  var opts = (0, utils_js_1.checkOpts)({
    dkLen: 32,
    asyncTick: 10
  }, _opts);
  var c = opts.c,
      dkLen = opts.dkLen,
      asyncTick = opts.asyncTick;
  (0, utils_js_1.assertNumber)(c);
  (0, utils_js_1.assertNumber)(dkLen);
  (0, utils_js_1.assertNumber)(asyncTick);
  if (c < 1) throw new Error('PBKDF2: iterations (c) should be >= 1');
  var password = (0, utils_js_1.toBytes)(_password);
  var salt = (0, utils_js_1.toBytes)(_salt); // DK = PBKDF2(PRF, Password, Salt, c, dkLen);

  var DK = new Uint8Array(dkLen); // U1 = PRF(Password, Salt + INT_32_BE(i))

  var PRF = hmac_js_1.hmac.create(hash, password);

  var PRFSalt = PRF._cloneInto().update(salt);

  return {
    c: c,
    dkLen: dkLen,
    asyncTick: asyncTick,
    DK: DK,
    PRF: PRF,
    PRFSalt: PRFSalt
  };
}

function pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
  PRF.destroy();
  PRFSalt.destroy();
  if (prfW) prfW.destroy();
  u.fill(0);
  return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */


function pbkdf2(hash, password, salt, opts) {
  var _pbkdf2Init = pbkdf2Init(hash, password, salt, opts),
      c = _pbkdf2Init.c,
      dkLen = _pbkdf2Init.dkLen,
      DK = _pbkdf2Init.DK,
      PRF = _pbkdf2Init.PRF,
      PRFSalt = _pbkdf2Init.PRFSalt;

  var prfW; // Working copy

  var arr = new Uint8Array(4);
  var view = (0, utils_js_1.createView)(arr);
  var u = new Uint8Array(PRF.outputLen); // DK = T1 + T2 + ⋯ + Tdklen/hlen

  for (var ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen) {
    // Ti = F(Password, Salt, c, i)
    var Ti = DK.subarray(pos, pos + PRF.outputLen);
    view.setInt32(0, ti, false); // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
    // U1 = PRF(Password, Salt + INT_32_BE(i))

    (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);

    Ti.set(u.subarray(0, Ti.length));

    for (var ui = 1; ui < c; ui++) {
      // Uc = PRF(Password, Uc−1)
      PRF._cloneInto(prfW).update(u).digestInto(u);

      for (var i = 0; i < Ti.length; i++) {
        Ti[i] ^= u[i];
      }
    }
  }

  return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}

exports.pbkdf2 = pbkdf2;

function pbkdf2Async(_x, _x2, _x3, _x4) {
  return _pbkdf2Async.apply(this, arguments);
}

function _pbkdf2Async() {
  _pbkdf2Async = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(hash, password, salt, opts) {
    var _pbkdf2Init2, c, dkLen, asyncTick, DK, PRF, PRFSalt, prfW, arr, view, u, _loop, ti, pos;

    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _pbkdf2Init2 = pbkdf2Init(hash, password, salt, opts), c = _pbkdf2Init2.c, dkLen = _pbkdf2Init2.dkLen, asyncTick = _pbkdf2Init2.asyncTick, DK = _pbkdf2Init2.DK, PRF = _pbkdf2Init2.PRF, PRFSalt = _pbkdf2Init2.PRFSalt;
            // Working copy
            arr = new Uint8Array(4);
            view = (0, utils_js_1.createView)(arr);
            u = new Uint8Array(PRF.outputLen); // DK = T1 + T2 + ⋯ + Tdklen/hlen

            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(ti, pos) {
              var Ti;
              return _regeneratorRuntime().wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      // Ti = F(Password, Salt, c, i)
                      Ti = DK.subarray(pos, pos + PRF.outputLen);
                      view.setInt32(0, ti, false); // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
                      // U1 = PRF(Password, Salt + INT_32_BE(i))

                      (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);

                      Ti.set(u.subarray(0, Ti.length));
                      _context.next = 6;
                      return (0, utils_js_1.asyncLoop)(c - 1, asyncTick, function (i) {
                        // Uc = PRF(Password, Uc−1)
                        PRF._cloneInto(prfW).update(u).digestInto(u);

                        for (var _i = 0; _i < Ti.length; _i++) {
                          Ti[_i] ^= u[_i];
                        }
                      });

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop);
            });
            ti = 1, pos = 0;

          case 6:
            if (!(pos < dkLen)) {
              _context2.next = 11;
              break;
            }

            return _context2.delegateYield(_loop(ti, pos), "t0", 8);

          case 8:
            ti++, pos += PRF.outputLen;
            _context2.next = 6;
            break;

          case 11:
            return _context2.abrupt("return", pbkdf2Output(PRF, PRFSalt, DK, prfW, u));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _pbkdf2Async.apply(this, arguments);
}

exports.pbkdf2Async = pbkdf2Async;